import { ChatDraft } from '@lib/chat/models/chat.state.interface';

export function handleChatDrafts(currentDrafts: ChatDraft[], chatDraft: ChatDraft): ChatDraft[] {
  const drafts = [...currentDrafts];

  if (!chatDraft.message) {
    return drafts.filter(draft => draft.threadId !== chatDraft.threadId);
  }

  const existingIndex = drafts.findIndex(d => d.threadId === chatDraft.threadId);
  if (existingIndex >= 0) {
    drafts[existingIndex] = chatDraft;
  } else {
    drafts.push(chatDraft);
  }

  return drafts;
}
